import { PolarAngleAxis, RadialBar, RadialBarChart } from 'recharts'
import styled from 'styled-components/macro'

import { Text, Tag, Layout } from '@loadsmart/miranda-react'

import { formatCurrency } from 'core/utils/currency'

import {
  getProbabilityChartFillVariant,
  getProbabilityPercentageText,
  getTagVariant,
} from '../../presenters/bidPresenter'

const GaugeWrapper = styled.div`
  height: 100px; /* recharts container accounts for a whole circular chart */
`

const MaxBidValue = styled(Text)`
  translate: 65px; // moving price closer to chart
  text-align: right;
  width: 70px;
`

const MinBidValue = styled(Text)`
  translate: -65px; // moving price closer to chart
  text-align: left;
  width: 70px;
`

const CustomTag = styled(Tag)`
  position: absolute;
  transform: translate(-50%, 110%);
`

const NoWrapGroup = styled(Layout.Group)`
  flex-wrap: nowrap;
`

export type BidGaugeProps = {
  probability?: number
  minBidValue: number
  maxBidValue?: number
}

export function BidGauge({ probability, minBidValue, maxBidValue }: BidGaugeProps) {
  return (
    <Layout.Stack>
      <Text>At this price, your odds of winning the bid are</Text>
      <Layout.Stack gap="spacing-2">
        <NoWrapGroup justify="center" align="flex-end">
          <MaxBidValue variant="body-md-bold">{`${formatCurrency(maxBidValue)}`}</MaxBidValue>
          <GaugeWrapper>
            <CustomTag variant={getTagVariant(probability)} size="large">
              {getProbabilityPercentageText(probability)}
            </CustomTag>
            <RadialBarChart
              width={300}
              height={200}
              innerRadius="85%"
              outerRadius="100%"
              data={[{ value: 100 - (probability ?? 0), fill: '#D9D9D9' }]}
              startAngle={0}
              endAngle={180}
              cy={100}
            >
              <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
              <RadialBar
                background={{ fill: getProbabilityChartFillVariant(probability) }}
                animationDuration={150}
                dataKey="value"
              />
            </RadialBarChart>
          </GaugeWrapper>
          <MinBidValue variant="body-md-bold">{`${formatCurrency(minBidValue)}`}</MinBidValue>
        </NoWrapGroup>
        <Layout.Group justify="space-around">
          <Text variant="body-sm" color="color-text-tertiary">
            Low chance
          </Text>
          <Text variant="body-sm" color="color-text-tertiary">
            High chance
          </Text>
        </Layout.Group>
      </Layout.Stack>
    </Layout.Stack>
  )
}
